export const formatWithSpaces = (value: number): string =>
    Math.round(value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const stripSpaces = (value: string): string => value.replace(/\s/g, '');

export const formatInputWithSpaces = (raw: string): string => {
    if (!raw) return '';
    const cleaned = stripSpaces(raw);
    const match = cleaned.match(/^(-?)(\d*)([.,]\d*)?(.*)$/);
    if (!match) return raw;
    const [, sign, intPart, decPart = '', rest = ''] = match;
    const intFormatted = intPart
        ? Number(intPart)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        : '';
    return `${sign}${intFormatted}${decPart}${rest}`;
};

export const parseBigNumber = (v: string): number => {
    const str = stripSpaces(String(v ?? '0'))
        .replace(',', '.')
        .trim();
    const blnMatch = str.match(/^(-?[\d.]+)\s*bln$/i);
    if (blnMatch) return Number(blnMatch[1]) * 1e12 || 0;
    const mldMatch = str.match(/^(-?[\d.]+)\s*mld$/i);
    if (mldMatch) return Number(mldMatch[1]) * 1e9 || 0;
    const mlnMatch = str.match(/^(-?[\d.]+)\s*mln$/i);
    if (mlnMatch) return Number(mlnMatch[1]) * 1e6 || 0;
    return Number(str) || 0;
};
